import { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

export function Greeting({ firstName }: { firstName?: string }): ReactElement {
  const greetingKey = `frontpage.mainContent.greetings.hour${new Date().getHours()}`;
  return (
    <>
      <FormattedMessage id={greetingKey} /> {firstName}
    </>
  );
}
